import React from 'react';

function About() {
    return (
        <div className="about-container">
            <h2 className="about-title">About Us</h2>
            <p className="about-text">We are a team of experienced Korean language teachers who are passionate about helping people learn the Korean language and culture.</p>
            <h3 className="about-subtitle">Our Mission</h3>
            <p className="about-text">Our mission is to provide high-quality Korean language classes that are accessible and affordable to everyone, regardless of their background or level of experience.</p>
            <h3 className="about-subtitle">Our Approach</h3>
            <p className="about-text">Our approach to teaching the Korean language is communicative and student-centered. We believe in creating a supportive and engaging learning environment where students can develop their language skills and cultural understanding through meaningful interactions with others.</p>
        </div>
    );
}

export default About;
